import React, { useState } from "react";
import { Wrapper, Container } from "./style";
import Content from "./components/Content";
import Header from "../components/Header";
import { MODAL_REJECTION_REQUEST } from "store/Modals/constants";

const RejectionRequestModal = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Wrapper>
      <Container expanded={expanded}>
        <Header expanded={expanded} setExpanded={setExpanded} modal={MODAL_REJECTION_REQUEST} title={"Solicitud de rechazo"}/>
        <Content expanded={expanded} />
      </Container>
    </Wrapper>
  );
};

export default RejectionRequestModal;
